import { HiOutlineUser, HiOutlineEnvelope } from "react-icons/hi2";
import { QuickTrade } from "@sdk/shared/types/order.types";

export const BASE_URL = "https://app.iexchange.global";
export const ORDER_PAGE = (orderId: string) => `/order/view/?id=${orderId}`;
export const P2P_PAGE = "/p2p";
export const QUICK_TRADE_PAGE = "/quick-trade";
export const HOME_PAGE = QUICK_TRADE_PAGE;
export const P2P_PAGE_EXTERNAL = BASE_URL + P2P_PAGE;
export const DASHBOARD_PAGE = "/dashboard";
export const POST_AD_PAGE = "/post-ad";
export const EDIT_AD_PAGE = (adId: string | number) => "/post-ad/edit?id=" + adId;
export const EDIT_AUTO_AD_PAGE = (adId: string | number) => "/auto-trading/ads/edit?id=" + adId;
export const ORDER_HISTORY_PAGE = "/dashboard/history/orders";
export const APPEALS_PAGE = "/appeals";
export const MY_ADS_PAGE = "/my-ads";
export const KYC_PAGE = "/user-kyc";
export const KYC_PAGE_EXTERNAL = BASE_URL + KYC_PAGE;
export const SELECT_PAYMENT_METHOD_PAGE = (searchParams: string) => QUICK_TRADE_PAGE + `2?${searchParams}`;
export const ADMIN_ROUTE = "/admin";
export const ADMIN_ANALYTICS_ROUTE = "/admin/analytics";
export const AUTO_TRADING_PAGE = "/auto-trading";
export const AUTO_TRADING_REGISTER_PAGE = "/register-auto";
export const AUTO_TRADING_CREATE_AD_PAGE = "/auto-trading/ads/create";
export const ADMIN_AUTOTRADER_PAGE = "/admin/autotrader";

export const WELCOME_PAGE = "/";
export const FAQ_PAGE = "/faq";
export const HELP_PAGE = "/help";
export const PRIVACY_POLICY_PAGE = "/privacy-policy";
export const BUY_SELL_PAGE =
  "https://scribehow.com/embed/How_to_BuySell_on_iExchange__lCmCyQVLTLmS1JkgJ06QXw?as=scrollable";
export const PLACING_AD_PAGE =
  "https://scribehow.com/embed/How_to_place_an_ad_on_iExchange__VERdj9CgRxS0PmI4xrtlXw?as=scrollable";
export const MERCHANT_PAGE =
  "https://scribehow.com/embed/How_to_place_an_ad_on_iExchange__5QzAizAaSWOZb--4FxfTqA?as=scrollable";
export const SETTLER_PAGE = HELP_PAGE + "/become-settler";
// export const BUY_SELL_PAGE = HELP_PAGE + "/buy-sell";
// export const PLACING_AD_PAGE = HELP_PAGE + "/place-ad";
// export const MERCHANT_PAGE = HELP_PAGE + "/become-merchant";
// export const SETTLER_PAGE = HELP_PAGE + "/become-settler";

export const primaryNavigationLinks = [
  {
    title: "P2P",
    isActive: false,
    href: HOME_PAGE,
    needsAuth: false,
  },
  {
    title: "Appeals",
    isActive: false,
    href: APPEALS_PAGE,
    needsAuth: false,
  },
  {
    title: "My ads",
    isActive: false,
    href: MY_ADS_PAGE,
    needsAuth: true,
  },
  {
    title: "help Center",
    icon: HiOutlineUser,
    isActive: false,
    href: HELP_PAGE,
    needsAuth: false,
  },
  {
    title: "Account",
    icon: HiOutlineEnvelope,
    isActive: false,
    needsAuth: true,
  },
];

export const resourcesLinks = [
  {
    title: "Welcome",
    href: WELCOME_PAGE,
  },
  {
    title: "FAQ",
    href: FAQ_PAGE,
  },
  {
    title: "Help",
    href: HELP_PAGE,
  },
  {
    title: "Privacy Policy",
    href: PRIVACY_POLICY_PAGE,
  },
];

export const PROTECTED_ROUTES = [ORDER_PAGE, POST_AD_PAGE, DASHBOARD_PAGE];
